// If you are adding a term to the Source glossary,
// please add a member of the Data team to your PR

// Due to overlap between the name property of Screen events and the
// source property of UI, Track, and Operational events, we group
// them together in this file.
// https://hello.atlassian.net/wiki/spaces/MEASURE/pages/134329599/Analytics+Lesson+1+-+Event+Types

export const Source = {
  '@trello/feature-flag-client': '@trello/feature-flag-client',
  aboutThisBoardAdminListScreen: 'aboutThisBoardAdminListScreen',
  addPowerUpButton: 'addPowerUpButton',
  appHeader: 'appHeader',
  atlassianSwitcherHeaderButton: 'atlassianSwitcherHeaderButton',
  atlassianAccountOnboardingBanner: 'atlassianAccountOnboardingBanner',
  atlassianAccountOnboardingOverlay: 'atlassianAccountOnboardingOverlay',
  attachmentGetPowerUpInlineDialog: 'attachmentGetPowerUpInlineDialog',
  attachmentsGetPowerUpUpgradeInlineDialog:
    'attachmentsGetPowerUpUpgradeInlineDialog',
  avatarChangeModal: 'avatarChangeModal',
  boardMap: 'boardMap',
  boardMenuDrawerAboutScreen: 'boardMenuDrawerAboutScreen',
  boardMenuDrawerActivityScreen: 'boardMenuDrawerActivityScreen',
  boardMenuDrawerArchiveScreen: 'boardMenuDrawerArchiveScreen',
  boardMenuDrawerBackgroundScreen: 'boardMenuDrawerBackgroundScreen',
  boardMenuDrawerBackgroundColorsScreen:
    'boardMenuDrawerBackgroundColorsScreen',
  boardMenuDrawerBackgroundPhotosScreen:
    'boardMenuDrawerBackgroundPhotosScreen',
  boardMenuDrawerCollectionsScreen: 'boardMenuDrawerCollectionsScreen',
  boardMenuDrawerDefaultScreen: 'boardMenuDrawerDefaultScreen',
  boardMenuDrawerEnterpriseUpsellInlineDialog:
    'boardMenuDrawerEnterpriseUpsellInlineDialog',
  boardMenuDrawerFilterScreen: 'boardMenuDrawerFilterScreen',
  boardMenuDrawerMoreScreen: 'boardMenuDrawerMoreScreen',
  boardMenuDrawerSettingsScreen: 'boardMenuDrawerSettingsScreen',
  boardScreen: 'boardScreen',
  boardSidebarDrawer: 'boardSidebarDrawer',
  boardsScreen: 'boardsScreen',
  cardDetailScreen: 'cardDetailScreen',
  changeBoardPermissionsInlineDialog: 'changeBoardPermissionsInlineDialog',
  changeBoardVisibilityInlineDialog: 'changeBoardVisibilityInlineDialog',
  changeEmailInlineDialog: 'changeEmailInlineDialog',
  changeEmailSubmittedInlineDialog: 'changeEmailSubmittedInlineDialog',
  changeEmailWarningInlineDialog: 'changeEmailWarningInlineDialog',
  createBoardModal: 'createBoardModal',
  createCardFromTemplateInlineDialog: 'createCardFromTemplateInlineDialog',
  emailToBoardSettingsInlineDialog: 'emailToBoardSettingsInlineDialog',
  exportBoardInlineDialog: 'exportBoardInlineDialog',
  homeScreen: 'homeScreen',
  inviteToBoardInlineDialog: 'inviteToBoardInlineDialog',
  linkCopyModal: 'linkCopyModal',
  miniProfileModal: 'miniProfileModal',
  memberHomeScreen: 'memberHomeScreen',
  onboardingDialog: 'onboardingDialog',
  powerUpCard: 'powerUpCard',
  printAndExportBoardInlineDialog: 'printAndExportBoardInlineDialog',
  profileAndVisibilitySettingsScreen: 'profileAndVisibilitySettingsScreen',
  publicDirectoryAllCategoriesScreen: 'publicDirectoryAllCategoriesScreen',
  publicDirectoryCategoryScreen: 'publicDirectoryCategoryScreen',
  publicDirectoryHomeScreen: 'publicDirectoryHomeScreen',
  publicDirectoryPowerUpDetailsScreen: 'publicDirectoryPowerUpDetailsScreen',
  publicDirectoryScreen: 'publicDirectoryScreen',
  publicDirectorySearchResultsScreen: 'publicDirectorySearchResultsScreen',
  publicPowerUpAddToBoardScreen: 'publicPowerUpAddToBoardScreen',
  publicPowerUpDetailsScreen: 'publicPowerUpDetailsScreen',
  searchInlineDialog: 'searchInlineDialog',
  setPrimaryEmailInlineDialog: 'setPrimaryEmailInlineDialog',
  stickerHoverView: 'stickerHoverView',
  stickerEditView: 'stickerEditView',
  templates: 'templates',
  templateCategoryScreen: 'templateCategoryScreen',
  templateGalleryScreen: 'templateGalleryScreen',
  templateStoryPageScreen: 'templateStoryPageScreen',
  votingSettingsInlineDialog: 'votingSettingsInlineDialog',
} as const;

export type SourceType = typeof Source[keyof typeof Source];

export const isValidSource = (s: SourceType) => {
  const validSources = Object.values(Source);
  return validSources.includes(s);
};
